import { render, staticRenderFns } from "./SettingsBar.vue?vue&type=template&id=94dfa916"
import script from "./SettingsBar.vue?vue&type=script&lang=ts"
export * from "./SettingsBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94dfa916')) {
      api.createRecord('94dfa916', component.options)
    } else {
      api.reload('94dfa916', component.options)
    }
    module.hot.accept("./SettingsBar.vue?vue&type=template&id=94dfa916", function () {
      api.rerender('94dfa916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/SettingsBar.vue"
export default component.exports